"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wizardContext = exports.WizardProvider = void 0;
var _react = require("react");
const wizardContext = exports.wizardContext = /*#__PURE__*/(0, _react.createContext)({});
const WizardProvider = exports.WizardProvider = wizardContext.Provider;
